/** Starter documents — loaded via template picker (confirms before replace). */

export const TEMPLATE_PROPOSAL = `# Proposal — {{TITLE}}

**Client:** {{CLIENT}}  
**Date:** {{DATE}}  
**Version:** {{VERSION}}

---

## Context

Briefly describe the client situation and why this document exists.

## Objectives

- What success looks like for the client
- Decisions this proposal supports

## Proposed approach

### Phase 1 — Discovery

Scope, activities, and intended outcomes.

### Phase 2 — Delivery

Deliverables and timeline overview.

## Scope & boundaries

| In scope | Out of scope |
|----------|----------------|
| …        | …              |

**Assumptions**

- …

## Deliverables

1. …
2. …

## Timeline & dependencies

| Milestone | Target | Notes |
|-----------|--------|-------|
| …         | …      | …     |

What we need from the client (access, approvals, data): …

## Commercial summary *(optional)*

Options, fee model, what is included.

## Next steps

1. …
2. …

---

*Confidential — prepared for {{CLIENT}}.*
`;

export const TEMPLATE_MEETING_NOTES = `# Meeting notes — {{TITLE}}

**Date:** {{DATE}}  
**Attendees:** …  
**Client / project:** {{CLIENT}}

---

## Agenda

1. …

## Discussion

### Topic 1

- …

### Topic 2

- …

## Decisions

- …

## Action items

| Owner | Action | Due |
|-------|--------|-----|
| …     | …      | …   |

## Next meeting

- …
`;

export const TEMPLATE_ONE_PAGER = `# {{TITLE}}

**For:** {{CLIENT}} · **Date:** {{DATE}} · **v{{VERSION}}**

---

## Summary

One short paragraph on the opportunity or recommendation.

## Why it matters

- …
- …

## What we propose

1. …
2. …

## Investment & timeline *(high level)*

- …

## Next step

…
`;

export const DOCUMENT_TEMPLATES = [
  {
    id: "proposal",
    label: "Client proposal",
    description: "Structured proposal with scope, phases, and next steps",
    body: TEMPLATE_PROPOSAL,
  },
  {
    id: "meeting",
    label: "Meeting notes",
    description: "Agenda, decisions, and action items",
    body: TEMPLATE_MEETING_NOTES,
  },
  {
    id: "onepager",
    label: "One-pager",
    description: "Short executive summary format",
    body: TEMPLATE_ONE_PAGER,
  },
];
